module.exports = __webpack_public_path__ + "img/07.d40ca45f.jpg";